/* ============
 * Getters for the admin-users module
 * ============
 *
 * The getters that are available on the
 * admin-users module.
 */

export default {
  getPathIndex: state => item => state.menu.pathList.findIndex(elmt => elmt.id === item.id),
  getLastPathItem: state => state.menu.pathList[state.menu.pathList.length - 1],
};



// WEBPACK FOOTER //
// ./src/store/modules/admin-users/getters.js